import ArrowForwardIcon from 'assets/svg/arrow/arrow-forward-bold.svg'
import ProductCard from 'common/components/Card/ProductCard'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import React, { useState } from 'react'
import styled from 'styled-components'

const control = `
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: 40px;
  height: 40px;
  margin-top: -22px;
  box-shadow: 0 6px 16px 0 rgba(134, 134, 134, 0.14);
  background-color: ${theme.colors.white};
  border-radius: 50%;
  user-select: none;
  justify-content: center;
  align-items: center;
  display: flex;
`

const Prev = styled.a`
  ${control};
  left: 0;
  display: ${(props) => (props.show ? 'flex' : ' none')};
`

const Next = styled.a`
  ${control};
  right: 0;
  display: ${(props) => (props.show ? 'flex' : ' none')};
`

const ProductCardsContainer = styled.div`
  height: 325px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 4px;
  transform: translateX(-${(props) => props.transform}px);
  transition: transform 0.5s ease;
  margin: 0 0 0 ${(props) => (props.isBannerExist ? 0 : '-18px')};
`

const StyledProductCard = styled.div`
  margin: 0 0 0 20px;
`

const Container = styled.div`
  width: 100vw;
  height: 325px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  position: relative;
`

const RightArrow = styled(ArrowForwardIcon)``

const LeftArrow = styled(ArrowForwardIcon)`
  transform: scaleX(-1);
`

interface ICarousel {
  products?: any[]
  isBannerExist?: boolean
}

function Carousel({
  products = [],
  isBannerExist,
}: ICarousel): JSX.Element {
  const [transform, setTransform] = useState<number>(0)

  // 2310 = banner width 290 + 20 banner gap + max 10 card * 180 card width + max 10 card * 20 gap width
  // 2000 = max 10 card * 180 card width + max 10 card * 20 gap width
  const maxTransform = isBannerExist ? 2310 : 2000

  /*
    1196 = remaining width on second slide
    290 = banner width
    10 = max card
    180 = card width
    20 = card gap
  */

  const onClickRightArrow = () => {
    setTransform(
      maxTransform -
        (1196 +
          (10 - products.length) * 180 +
          (10 - products.length) * 20),
    )
  }

  const onClickLeftArrow = () => {
    setTransform(
      transform -
        maxTransform -
        (1196 +
          (10 - products.length) * 180 +
          (10 - products.length) * 20),
    )
  }

  return (
    <Container data-testid="carousel-test">
      <ProductCardsContainer
        transform={transform}
        isBannerExist={isBannerExist}
      >
        {products?.map((product, index) => {
          return (
            <StyledProductCard key={`${index + 1}`}>
              <ProductCard
                maskedPrice={product?.masked_price}
                maskedDiscount={product?.masked_discount}
                percentage={product?.discount_percentage}
                isShowRating={product?.is_show_rating}
                image={product.default_image}
                name={product.name}
                currentPrice={product.discount}
                previousPrice={product.price}
                productURL={`${WEB_DESKTOP_RALALI_URL}/v/${product.microsite_url}/product/${product.alias}`}
                unit={
                  product.unit ? `Per ${product.unit}` : 'Per Unit'
                }
                rating={product.rating}
                location={product.city_name || product.province_name}
                sellerMembershipBadge={product.ss_type_images}
                isFreeShipping={
                  product.free_ongkir_lokal === 'Y'
                    ? true
                    : !!(
                        false || product.free_ongkir_nusantara === 'Y'
                      )
                }
                storeName={product.name_shop}
              />
            </StyledProductCard>
          )
        })}
      </ProductCardsContainer>
      <Prev
        data-testid="carousel-control-prev-test"
        show={transform > 0}
        onClick={() => onClickLeftArrow()}
      >
        <LeftArrow />
      </Prev>
      <Next
        data-testid="carousel-control-next-test"
        show={
          (isBannerExist && products?.length > 4 && transform <= 0) ||
          (!isBannerExist && products?.length > 5 && transform === 0)
        }
        onClick={() => onClickRightArrow()}
      >
        <RightArrow />
      </Next>
    </Container>
  )
}

export default Carousel
